import { render, staticRenderFns } from "./FrontendUsers.vue?vue&type=template&id=533eb944&scoped=true"
import script from "./FrontendUsers.vue?vue&type=script&lang=js"
export * from "./FrontendUsers.vue?vue&type=script&lang=js"
import style0 from "./FrontendUsers.vue?vue&type=style&index=0&id=533eb944&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533eb944",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/home/bazzite/Work/awardapplication/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('533eb944')) {
      api.createRecord('533eb944', component.options)
    } else {
      api.reload('533eb944', component.options)
    }
    module.hot.accept("./FrontendUsers.vue?vue&type=template&id=533eb944&scoped=true", function () {
      api.rerender('533eb944', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/dashboard/components/FrontendUsers.vue"
export default component.exports